import React from 'react';

//assets
import './mobile-app-banner.scss';
import x_close from 'assets/icons/x-close-mobile-icon.svg';
import arrow from 'assets/icons/slider-arrow-blue.svg';
import {getMediaPath} from "../../../../app/functions";

function MobileAppBanner(props) {
    return (
        <section className="mobile-app-banner">
            <div className="x-close" onClick={ props.dismiss }>
                <img src={ getMediaPath(x_close) } alt="" />
            </div>
            <a className="link" href={ props.link } target="_blank" rel="noopener noreferrer">
                <div className="details">
                    <div className="title">{ props.title }</div>
                    <div className="subtitle">{ props.subtitle }</div>
                </div>
                <div className="arrow">
                    <img src={ getMediaPath(arrow) } alt="" />
                </div>
            </a>
        </section>
    );
}
export default MobileAppBanner;
